module.exports = __webpack_public_path__ + "static/media/surf-byron-bay.49685645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/surf-byron-bay.jpg
// module id = 150
// module chunks = 0